var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHappyWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6,
    cy: 15.065,
    r: 15,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21214D",
    d: "M12.602 11.488c0 1.516-1.07 2.745-2.39 2.745s-2.39-1.229-2.39-2.745c0-1.515 1.07-2.744 2.39-2.744s2.39 1.229 2.39 2.744ZM23.378 11.488c0 1.516-1.07 2.745-2.39 2.745s-2.39-1.229-2.39-2.745c0-1.515 1.07-2.744 2.39-2.744s2.39 1.229 2.39 2.744Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.62 10.674a.868.868 0 1 1-1.736 0 .868.868 0 0 1 1.736 0ZM21.396 10.674a.868.868 0 1 1-1.736 0 .868.868 0 0 1 1.736 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21214D",
    d: "m22.097 20.61-.015-.014c-.45-.39-1.193-.28-1.763.117a7.397 7.397 0 0 1-2.454 1.126 7.822 7.822 0 0 1-2.266.33 7.753 7.753 0 0 1-2.273-.333 7.408 7.408 0 0 1-2.444-1.123c-.57-.397-1.313-.506-1.763-.117l-.018.014c-.446.38-.326 1.271.383 1.88a9.994 9.994 0 0 0 5.457 2.34c.217.012.437.021.66.021.222 0 .442-.009.66-.021a9.975 9.975 0 0 0 5.453-2.34c.712-.608.833-1.5.383-1.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappyWhite);
export default __webpack_public_path__ + "static/media/icon-happy-white.14c381a9ee9c57dd6e53f3d5fa3314e4.svg";
export { ForwardRef as ReactComponent };